<div class="edittablebdr m-0">
  <div class="rtnav ui-g">
    <div class="ui-g-8 msgbox-8">
      @for (message of msgsPoe; track message) {
        <p-message [life]="3000" [text]="message.detail"></p-message>
      }
    </div>
    @if (!btnNavPoe) {
      <div class="ui-g-3"></div>
    }
    @if (btnNavPoe) {
      <div class="ui-g-3">
        <button
          type="button"
          pButton
          (click)="CancelPoeInformation()"
          class="ui-button-secondary flat fl-rt">
          Cancel
        </button>
        <button
          type="submit"
          pButton
          [disabled]="buttonClicked"
          (click)="onSubmitPOEInformation()"
          class="flat btnmr fl-rt">
          Save
        </button>
      </div>
    }
    <div class="ui-g-1 edit-history-icon">
      <span
        class="fa fa-pencil ico cpointer fl-rt"
        pTooltip="Edit"
        (click)="editPoeInformation()"
        (keydown.enter)="editPoeInformation()"
        tabindex="0"
        tooltipPosition="bottom"></span>
    </div>
  </div>
  <form [formGroup]="eventPoeInformationForm">
    <div class="readonlytbox payment-details">
      <div class="ui-g">
        <div class="ui-g-12 ui-md-8 ui-lg-8">
          <div class="ui-g">
            <div class="ui-g-12 ui-md-6 ui-lg-6">Scheduled Engagement Date</div>
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <p-datepicker
                appendTo="body"
                formControlName="scheduledEventDate"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yy"
                [readonlyInput]="true"
                [showOnFocus]="false"
                [showIcon]="isReadonlyPOE === false"
                [iconDisplay]="'input'"
                [class.readonlycaltb]="isReadonlyPOE === true"
                [defaultDate]="maxYearDate">
              </p-datepicker>
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-12 ui-md-6 ui-lg-6">Expected POE Date</div>
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <p-datepicker
                appendTo="body"
                [readonlyInput]="true"
                formControlName="expectedPOEDate"
                dateFormat="mm/dd/yy"
                [readonlyInput]="true"
                [showOnFocus]="false"
                [showIcon]="isReadonlyPOE === false"
                [iconDisplay]="'input'"
                [class.readonlycaltb]="isReadonlyPOE === true"
                [defaultDate]="maxYearDate"></p-datepicker>
            </div>
          </div>
          @if (!isMRPPProgram) {
            <div class="ui-g">
              <div class="ui-g-12 ui-md-6 ui-lg-6">Month Payment Submitted</div>
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <p-select
                  appendTo="body"
                  [options]="monthList"
                  [readonly]="isReadonlyPOE"
                  [class.readonlydd]="isReadonlyPOE === true"
                  formControlName="expectedPaymentMonth"
                  placeholder="--SELECT--"
                  optionLabel="fiscal_Month"></p-select>
              </div>
            </div>
          }
          <div class="ui-g">
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              Confidence (High, Medium, Low, Received)
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <p-select
                appendTo="body"
                [options]="confidence"
                [readonly]="isReadonlyPOE"
                [class.readonlydd]="isReadonlyPOE === true"
                formControlName="confidence"
                placeholder="--SELECT--"
                optionLabel="confidence"></p-select>
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              Pre-Sales Engagement Date (Workshop Completion Date)
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <p-datepicker
                appendTo="body"
                [readonlyInput]="true"
                formControlName="eventCompletionDate"
                dateFormat="mm/dd/yy"
                [readonlyInput]="true"
                [showOnFocus]="false"
                [showIcon]="isReadonlyPOE === false"
                [iconDisplay]="'input'"
                [class.readonlycaltb]="isReadonlyPOE === true"
                [defaultDate]="maxYearDate"></p-datepicker>
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-12 ui-md-6 ui-lg-6">Engagement Type Completed</div>
            @if (!isMRPPProgram && !isDealAssociation) {
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <p-select
                  appendTo="body"
                  [options]="eventTypes"
                  readonly
                  [class.readonlydd]="true"
                  formControlName="eventTypeCompleted"
                  placeholder="--SELECT--"
                  optionLabel="eventName"></p-select>
              </div>
            }
            @if (isMRPPProgram || isDealAssociation) {
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <p-select
                  appendTo="body"
                  [options]="eventTypes"
                  [readonly]="isReadonlyPOE"
                  [class.readonlydd]="isReadonlyPOE === true"
                  formControlName="eventTypeCompleted"
                  placeholder="--SELECT--"
                  optionLabel="eventName"></p-select>
              </div>
            }
          </div>
          @if (
            isMultiTargetProductSupported &&
            !isMRPPProgram &&
            !isDealAssociation
          ) {
            <div class="ui-g">
              <div class="ui-g-12 ui-md-6 ui-lg-6">Target Product</div>
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <p-select
                  appendTo="body"
                  [options]="eventTargetProducts"
                  readonly
                  [class.readonlydd]="true"
                  formControlName="eventTargetProduct"
                  placeholder="--SELECT--"
                  optionLabel="name"></p-select>
              </div>
            </div>
          }
          @if (!isMRPPProgram && !isDealAssociation) {
            <div class="ui-g">
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                Partner Statement Sent Date
              </div>
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <p-datepicker
                  appendTo="body"
                  [readonlyInput]="true"
                  formControlName="partnerStatementSentDate"
                  dateFormat="mm/dd/yy"
                  [readonlyInput]="true"
                  [showOnFocus]="false"
                  [showIcon]="isReadonlyPOE === false"
                  [iconDisplay]="'input'"
                  [class.readonlycaltb]="isReadonlyPOE === true"
                  [defaultDate]="maxYearDate">
                </p-datepicker>
              </div>
            </div>
          }
          @if (!isDealAssociation) {
            <div class="ui-g">
              <div class="ui-g-12 ui-md-6 ui-lg-6">Payment Document Number</div>
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <input
                  type="text"
                  pInputText
                  [readonly]="isReadonlyPOE"
                  formControlName="statementNumber" />
              </div>
            </div>
          }
          @if (isDealAssociation) {
            <div class="ui-g">
              <div class="ui-g-12 ui-md-6 ui-lg-6">Payment Document Number</div>
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <input
                  type="text"
                  pInputText
                  readonly
                  formControlName="statementNumber" />
              </div>
            </div>
          }
          <div class="ui-g">
            @if (!isMRPPProgram) {
              <div class="ui-g-12 ui-md-6 ui-lg-6">MS Invoice Number</div>
            }
            @if (isMRPPProgram) {
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                Milestone 1 MS Invoice Number
              </div>
            }
            @if (!isDealAssociation) {
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <input
                  type="text"
                  pInputText
                  [readonly]="isReadonlyPOE"
                  formControlName="msInvoiceNumber" />
              </div>
            }
            @if (isDealAssociation) {
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <input
                  type="text"
                  pInputText
                  readonly
                  formControlName="msInvoiceNumber" />
              </div>
            }
          </div>
          <div class="ui-g">
            @if (!isMRPPProgram) {
              <div class="ui-g-12 ui-md-6 ui-lg-6">MS Invoice Paid Date</div>
            }
            @if (isMRPPProgram) {
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                Milestone 1 MS Invoice Paid Date
              </div>
            }
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <p-datepicker
                appendTo="body"
                [readonlyInput]="true"
                formControlName="msInvoicePaidDate"
                dateFormat="mm/dd/yy"
                [readonlyInput]="true"
                [showOnFocus]="false"
                [showIcon]="isReadonlyPOE === false"
                [iconDisplay]="'input'"
                [class.readonlycaltb]="isReadonlyPOE === true"
                [defaultDate]="maxYearDate"></p-datepicker>
            </div>
          </div>
          <div class="ui-g">
            @if (!isMRPPProgram) {
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                Payment Central Transaction ID
              </div>
            }
            @if (isMRPPProgram) {
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                Milestone 1 Payment Central Transaction ID
              </div>
            }
            @if (!isDealAssociation) {
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <input
                  type="text"
                  pInputText
                  [readonly]="isReadonlyPOE"
                  formControlName="paymentCentralTransactionId" />
              </div>
            }
            @if (isDealAssociation) {
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <input
                  type="text"
                  pInputText
                  readonly
                  formControlName="paymentCentralTransactionId" />
              </div>
            }
          </div>
          <div class="ui-g">
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              Partner Payment Profile Status
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <p-radioButton
                name="ppS1"
                [disabled]="isReadonlyPOE"
                value="true"
                formControlName="partnerPaymentProfileStatus"
                inputId="ppS"></p-radioButton>
              <label for="ppS" class="ml-2">Yes</label>
              <p-radioButton
                name="ppS1"
                class="ml-4"
                [disabled]="isReadonlyPOE"
                value="false"
                formControlName="partnerPaymentProfileStatus"
                inputId="ppS"></p-radioButton>
              <label for="ppS" class="ml-2">No</label>
            </div>
          </div>
          @if (!isMRPPProgram && !isDealAssociation) {
            <div class="ui-g">
              <div class="ui-g-12 ui-md-6 ui-lg-6">Supplier ID</div>
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <input
                  type="text"
                  pInputText
                  readonly
                  formControlName="supplierId" />
              </div>
            </div>
          }
          <div class="ui-g">
            <div class="ui-g-12 ui-md-6 ui-lg-6">Payee ID</div>
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <input
                type="text"
                pInputText
                readonly
                formControlName="payeeId" />
            </div>
          </div>
          @if (!isMRPPProgram) {
            <div class="ui-g">
              <div class="ui-g-12 ui-md-6 ui-lg-6">Payee Name</div>
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <input
                  type="text"
                  pInputText
                  readonly
                  formControlName="payeeName" />
              </div>
            </div>
          }
          <div class="ui-g">
            <div class="ui-g-12 ui-md-6 ui-lg-6">Agreement</div>
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <p-radioButton
                name="agre1"
                [disabled]="true"
                value="true"
                formControlName="agreement"
                inputId="agre"></p-radioButton>
              <label for="agre" class="ml-2">Yes</label>
              <p-radioButton
                name="agre1"
                class="ml-4"
                [disabled]="true"
                value="false"
                formControlName="agreement"
                inputId="agre"></p-radioButton>
              <label for="agre" class="ml-2">No</label>
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-12 ui-md-6 ui-lg-6">Submitted Date</div>
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <input
                type="text"
                pInputText
                readonly
                formControlName="submittedDate" />
            </div>
          </div>
          @if (isMRPPProgram) {
            <div class="ui-g">
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                Date Milestone 1 Completed
              </div>
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <p-datepicker
                  appendTo="body"
                  formControlName="milestoneOneCompletionDate"
                  dateFormat="mm/dd/yy"
                  placeholder="mm/dd/yy"
                  [readonlyInput]="true"
                  [showOnFocus]="false"
                  [showIcon]="isReadonlyPOE === false"
                  [iconDisplay]="'input'"
                  [class.readonlycaltb]="isReadonlyPOE === true"
                  [defaultDate]="maxYearDate">
                </p-datepicker>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </form>
</div>
